(function () {
  if (window.spyVatPriceObserverInitializedV7) return;
  window.spyVatPriceObserverInitializedV7 = true;

  function parseGermanPrice(text) {
    var normalized = String(text || '').replace(/[^\d,.-]/g, '');
    var commaIndex = normalized.lastIndexOf(',');
    var dotIndex = normalized.lastIndexOf('.');

    if (commaIndex > dotIndex) {
      normalized = normalized.replace(/\./g, '').replace(',', '.');
    } else if (dotIndex > commaIndex && commaIndex !== -1) {
      normalized = normalized.replace(/,/g, '');
    } else if (commaIndex !== -1) {
      normalized = normalized.replace(',', '.');
    }

    return Number.parseFloat(normalized);
  }

  function isVisible(element) {
    if (!element || element.getClientRects().length === 0) return false;

    var styles = window.getComputedStyle(element);
    return styles.display !== 'none' && styles.visibility !== 'hidden';
  }

  function formatGross(netAmount) {
    var value = Math.round(netAmount * 119) / 100;
    return '€' + value.toFixed(2).replace('.', ',') + ' Brutto';
  }

  function currentNetElement(priceRoot) {
    var easifyPrices = Array.from(priceRoot.querySelectorAll(
      '.tpo_product_price, [data-easify-live-price], .easify-price-amount, .easify-price'
    ));
    var visibleEasifyPrice = easifyPrices.find(function (price) {
      var amount = parseGermanPrice(price.textContent);
      return isVisible(price) && Number.isFinite(amount) && amount > 0;
    });
    var easifyPrice = visibleEasifyPrice || easifyPrices.find(function (price) {
      var amount = parseGermanPrice(price.textContent);
      return Number.isFinite(amount) && amount > 0;
    });

    if (easifyPrice) return easifyPrice;

    return Array.from(priceRoot.querySelectorAll(
      '.price-item--sale:not(.price-item--compare), .price-item--regular, [data-easify-starting-price]'
    )).find(function (price) {
      var amount = parseGermanPrice(price.textContent);
      return isVisible(price) && Number.isFinite(amount) && amount > 0;
    });
  }

  function syncGrossProductPrices() {
    var priceRoots = Array.from(document.querySelectorAll('.productView-price')).filter(function (priceRoot) {
      return priceRoot.closest(
        '.productView-details, .halo-quick-view-popup, #shopify-section-featured-product, .featured-product'
      ) || priceRoot.querySelector(
        '.tpo_product_price, [data-easify-live-price], .easify-price-amount, .easify-price, [data-easify-starting-price]'
      );
    });

    priceRoots.forEach(function (priceRoot) {
      var netElement = currentNetElement(priceRoot);
      if (!netElement) return;

      var netAmount = parseGermanPrice(netElement.textContent);
      if (!Number.isFinite(netAmount) || netAmount < 0) return;

      var startingPrice = priceRoot.querySelector('[data-easify-starting-price]');
      var easifyPrice = Array.from(priceRoot.querySelectorAll(
        '.tpo_product_price, [data-easify-live-price], .easify-price-amount, .easify-price'
      )).find(function (price) {
        var amount = parseGermanPrice(price.textContent);
        return Number.isFinite(amount) && amount > 0;
      });

      if (startingPrice && easifyPrice) {
        startingPrice.hidden = true;
        easifyPrice.hidden = false;
        easifyPrice.style.removeProperty('display');
        easifyPrice.style.removeProperty('visibility');
      }

      var vatBlock = priceRoot.querySelector('.productView-vat-prices, .price-tax-display');
      if (!vatBlock) {
        vatBlock = document.createElement('div');
        vatBlock.className = 'productView-vat-prices';
        vatBlock.innerHTML =
          '<span class="productView-vat-prices__net">Nettopreis, zzgl. 19% MwSt.</span>' +
          '<strong class="productView-vat-prices__gross"></strong>';
        priceRoot.appendChild(vatBlock);
      }

      var grossPrice = vatBlock.querySelector(
        '.productView-vat-prices__gross, .price-tax-display__gross'
      );
      var formattedGross = formatGross(netAmount);

      if (grossPrice && grossPrice.textContent !== formattedGross) {
        grossPrice.textContent = formattedGross;
      }
    });
  }

  var syncFrame = null;
  var delayedSyncTimers = [];

  function clearDelayedSyncs() {
    delayedSyncTimers.forEach(window.clearTimeout);
    delayedSyncTimers = [];
  }

  function scheduleGrossPriceSync() {
    if (syncFrame) window.cancelAnimationFrame(syncFrame);
    clearDelayedSyncs();

    syncFrame = window.requestAnimationFrame(function () {
      syncFrame = null;
      syncGrossProductPrices();
    });

    [120, 400, 1000, 2500, 5000].forEach(function (delay) {
      delayedSyncTimers.push(window.setTimeout(syncGrossProductPrices, delay));
    });
  }

  function initializeVatPriceSync() {
    new MutationObserver(scheduleGrossPriceSync).observe(document.body, {
      childList: true,
      subtree: true
    });

    document.addEventListener('change', scheduleGrossPriceSync, true);
    document.addEventListener('input', scheduleGrossPriceSync, true);
    document.addEventListener('keyup', scheduleGrossPriceSync, true);
    document.addEventListener('click', scheduleGrossPriceSync, true);
    scheduleGrossPriceSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeVatPriceSync);
  } else {
    initializeVatPriceSync();
  }
})();
